import type { CurrentUser, Role } from '@/types/user'

type RoleHolder = { client_type?: Role | string | null } | null | undefined

export const isAdmin = (u: RoleHolder) => u?.client_type === 'admin'
export const isSubAdmin = (u: RoleHolder) => u?.client_type === 'sub-admin'
export const isAdminLike = (u: RoleHolder) => isAdmin(u) || isSubAdmin(u)
export const isTeamLead = (u: RoleHolder) => u?.client_type === 'team-lead' || u?.client_type === 'yt-helper-lead'
export const isEditor = (u: RoleHolder) => u?.client_type === 'qa' || u?.client_type === 'yt-helper' || u?.client_type === 'editor'
export const isCustomer = (u: RoleHolder) => u?.client_type === 'customer'
export const isStaff = (u: RoleHolder) => !!u && !isCustomer(u)

export const ROLE_LABELS: Record<Role, string> = {
  admin: 'Admin',
  'sub-admin': 'Sub-admin',
  'team-lead': 'Team Lead',
  qa: 'QA',
  editor: 'Editor',
  'yt-helper': 'YT Helper',
  'yt-helper-lead': 'YT Helper Lead',
  customer: 'Customer',
}

export function roleLabel(role: string | null | undefined): string {
  return (role && ROLE_LABELS[role as Role]) || role || ''
}

/** Whether a customer can open the new-request form (mirrors vidchops-fe). */
export function canCreateRequest(user: CurrentUser | null | undefined): { allowed: boolean; reason?: string } {
  if (!user) return { allowed: false }
  if (isAdmin(user)) return { allowed: true }
  if (!isCustomer(user)) return { allowed: false, reason: 'Only admins and customers can create requests.' }
  if (user.request_limit) {
    return {
      allowed: false,
      reason: 'You have reached the limit for video requests. Your limit refreshes on the next billing date.',
    }
  }
  if (!user.qas || user.qas.length === 0) {
    return { allowed: false, reason: 'We are still setting up your account for file sharing. We will email you once it is ready.' }
  }
  return { allowed: true }
}
